import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";

function Appointment() {
  const [data, setData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const patientData = useSelector((store) => store.patient.patientLogin);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const requestData = {
  //         patient_id: patientData?.contact_num,
  //         // patient_id: '03165573588',
  //         type: "basic",
  //       };
  //       const response = await SendPostRequest(
  //         "patient/all_appointments",
  //         requestData
  //       );
  //       setData(response?.data);
  //     } catch (error) {
  //       console.error("Error fetching dashboard stats:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);


  useEffect(() => {
  const fetchData = async () => {
    try {
      const requestData = {
        patient_id: patientData?.contact_num,
        type: "basic",
      };
      const response = await SendPostRequest(
        "patient/all_appointments",
        requestData
      );

      // sort latest record on top (agar approved_date use karna ho to uska bhi kar sakte hain)
      const sortedData = response?.data?.sort(
        (a, b) => new Date(b.requested_time) - new Date(a.requested_time)
      );

      setData(sortedData);
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  fetchData();
}, []);



  const handleView = async (uid) => {
    try {
      const requestData = {
        appointment_id: uid,
      };
      const response = await SendPostRequest(
        "patient/appointment_detail",
        requestData
      );
      setViewData(response?.data);
    } catch (error) {
      console.error("Error fetching: ", error);
    }
  };

  return (
    <div className="dashboard  Prescripition">
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "10px"
      }}>
        <h3>Appointments</h3>
        <Link to="/appointment">
          <button className="btn btn-default">Book An Appointment</button>
        </Link>

      </div>
      {!data ? (
        <div
          style={{ marginBottom: "100px" }}
          className="d-flex align-items-center justify-content-center"
        >
          <Spinner />
        </div>
      ) : data?.length === 0 ? (
        <div>
          <div className="table-responsive">
            <table className="table">
              <thead className="thead">
                <tr>
                  <th>Doctor Name</th>
                  <th>Requested</th>
                  <th>Approved</th>
                  <th>View</th>
                </tr>
              </thead>
            </table>
          </div>
          <div className="alert text-center fw-bold alert-danger" role="alert">
            No Basic Appointments Found
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table">
            <thead className="thead">
              <tr>
                <th>Doctor Name</th>
                <th>Requested</th>
                <th>Approved</th>
                <th col="2">Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((appointment) => (
                <tr key={appointment?.uid}>
                  {/* <td>{appointment?.doctor}</td> */}
                  <td className="appointment-tab-mobile-view">{appointment?.doctor || "--"}</td>

                  <td className="appointment-tab-mobile-view" style={{ textTransform: "capitalize" }}>
                    {/* {appointment?.requested_time.replace(" 12:00 AM", " - ") +
                      " " +
                      appointment?.shift} */}
                      {appointment?.requested_time + (appointment?.shift ? " - " + appointment.shift : "")}

                  </td>
                  <td className="appointment-tab-mobile-view">{appointment?.approved_date}</td>
                  <td className="appointment-tab-mobile-view col-2" col="2">
                  <div className="d-flex gap-2">

                      <button
                    className="btn btn-default"
                      onClick={() => handleView(appointment?.uid)}
                      data-toggle="modal"
                      data-target="#exampleModal"
                      style={{fontWeight:"lighter", fontSize:"16px"}}
                    >
                      View
                    </button>
                    {appointment?.arrival_status === "Prescribed" &&
                      appointment?.prescription_link && (
                        <a
                          href={appointment.prescription_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button type="button" className="prescribed-btn-bg-success" style={{fontWeight:"lighter", fontSize:"16px"}}>Prescribed</button>
                        </a>
                      )}
                  </div>
                    <div
                      class="modal fade appointments-modal-wrapper"
                      id="exampleModal"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h4 class="modal-title fw-bold" id="exampleModalLabel">
                              Appointment Detail
                            </h4>
                            <button
                              type="button"
                               class="btn btn-default"
                              data-dismiss="modal"
                              aria-label="Close"
                              // style={{color:"grey", fontSize:"28px"}}
                              style={{padding:"5px 10px",fontSize:"28px"}}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            {viewData && (
                              <div className="row">
                                <div className="col-6">
                                  <h5>Name: </h5>
                                  <p className="text-capitalize">{viewData[0]?.full_name || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Doctor: </h5>
                                  <p className="text-capitalize">{viewData[0]?.doctor || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Contact No: </h5>
                                  <p className="text-capitalize">{viewData[0]?.contact_number || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Status: </h5>
                                  <p className="text-capitalize">{viewData[0]?.status || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Requested Time: </h5>
                                  <p className="text-capitalize">{viewData[0]?.requested_time || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Approved Time: </h5>
                                  <p className="text-capitalize">{viewData[0]?.approved_date}</p>
                                </div>
                              </div>
                            )}
                          </div>

                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-default"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Appointment;
